import { render, staticRenderFns } from "./ConsultantMailPreferences.vue?vue&type=template&id=797628e2"
import script from "./ConsultantMailPreferences.vue?vue&type=script&lang=js"
export * from "./ConsultantMailPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports